<script lang="ts">
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import { onMount, getContext } from 'svelte';
	import DeleteIcon from 'assets/svg/delete.svg?component';
	import EditIcon from 'assets/svg/edit.svg?component';
	import DuplicateIcon from 'assets/svg/duplicate.svg?component';
	import AddWatchlistModal from 'components/AddWatchlistModal/AddWatchlistModal.svelte';
	import { _ } from 'utils/i18/i18n';
	import userStore from 'stores/user';
	import { deleteWatchlist } from 'services/watchlist/delete-watchlist';

	export let dark: boolean = false;
	export let listName: string = $_('watchlist.mainWatchList');
	export let isEditModeEnabled;
	export let list = [];
	export let watchlists;
	export let toggleWatchlist: (listName: string) => void;

	const fetchData: (arg?: boolean) => void = getContext('fetchData');
	let addWatchlistModalIsOpened = false;

	let isOpen: boolean = false;
	let inputRef;
	let variants = [
		{
			value: 'edit',
			name: $_('watchlist.edit'),
			icon: EditIcon,
			onClick: async () => {
				isEditModeEnabled = true;
				await fetchData(false);
			},
		},
		{
			value: 'delete',
			name: $_('watchlist.delete'),
			icon: DeleteIcon,
			onClick: async () => {
				delete $userStore.watchlist[listName];
				await deleteWatchlist($userStore._id, listName);
				toggleWatchlist('Main watchlist');
				await fetchData();
			},
		},
		{
			value: 'duplicate',
			name: $_('watchlist.duplicate'),
			icon: DuplicateIcon,
			onClick: () => {
				addWatchlistModalIsOpened = true;
			},
		},
	];

	onMount(() => {
		document.addEventListener('click', handleClose);

		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (inputRef && !inputRef.contains(e.target)) {
			isOpen = false;
		}
	};
</script>

<div class="wrapper" class:dark>
	<div
		bind:this={inputRef}
		class="options-wrapper"
		on:click={() => {
			isOpen = !isOpen;
		}}
	>
		<p class="menu-title">{$_('watchlist.more')}</p>

		{#if isOpen}
			<ArrowUp class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={5} />
		{:else}
			<ArrowDown class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={5} />
		{/if}
	</div>
	<ul class="variants border-shadow" class:visible={isOpen}>
		{#if listName === $_('watchlist.mainWatchList')}
			<li class="item" on:click={variants[2].onClick}>
				<div class="icon-wrapper">
					<DuplicateIcon width={12} height={12} class="selected-icon" />
					<p class="text">{variants[2].name}</p>
				</div>
			</li>
		{:else}
			{#each variants as variant (variant.value)}
				<li class="item" on:click={variant.onClick}>
					<div class="icon-wrapper">
						{#if variant.value === 'edit'}
							<EditIcon width={12} height={12} class="selected-icon" />
						{:else if variant.value === 'delete'}
							<DeleteIcon width={12} height={12} class="selected-icon" />
						{:else if variant.value === 'duplicate'}
							<DuplicateIcon width={12} height={12} class="selected-icon" />
						{/if}
						<p class="text">{variant.name}</p>
					</div>
				</li>
			{/each}
		{/if}
	</ul>
	<AddWatchlistModal
		{dark}
		uid={$userStore._id}
		active={addWatchlistModalIsOpened}
		watchlistData={list}
		toggleModal={() => (addWatchlistModalIsOpened = !addWatchlistModalIsOpened)}
		{toggleWatchlist}
		{watchlists}
	/>
</div>

<style lang="scss">
	@import 'watchlistOptionsMenu';
</style>
